<template>
  <div class="vehicle">
    <div class="vehicle-top">
      <div class="top-l">
        <el-input v-model="VIN" clearable placeholder="请输入车辆信息"></el-input>
        <el-button class="top-l-search" @click="searchClick()">查询</el-button>
        <el-button class="v-new" :disabled="customer_status==2" @click="addClick()">新增 +</el-button>
        <div style="clear:both;"></div>
      </div>
      <div style="clear:both;"></div>
    </div>
    <div class="vehicle-bottom">
      <div class="vehicle-table">
        <el-table
          :data="yemiandata"
          :header-cell-style="{background:'#f3f3f3',color:'#323232',height:'50px'}"
          border
          style="width: 100%">
          <el-table-column
            prop="vin"
            label="VIN"
            width="">
          </el-table-column>
          <el-table-column
            prop="plate_number"
            label="车牌号"
            width="">
              <template slot-scope="scope">{{ scope.row.plate_number | defaultValFilter }}</template>
          </el-table-column>
          <el-table-column
            prop="created_time"
            label="时间">
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button class="user-btn user-delete" :disabled="customer_status==2" @click="deleteClick(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          @size-change="handleSizeChange"
          @current-change="currentChange"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <!-- 新增 -->
    <el-dialog title :visible.sync="newVehicleDialog" @close="cancelClick()" customClass="new-vehicle-dialog" width="934px" :close-on-click-modal="false">
      <p class="title">新增</p>
      <div class="line"></div>
      <div class="new-vehicle-content">
        <div class="text-input">
          <div class="details">
            <div class="details-title">
              <span class="star">*</span>
              <span>VIN：</span>
            </div>
            <div class="details-r">
              <el-input v-model="plate_vin" clearable placeholder="请输入VIN"></el-input>
              <div style="clear:both;"></div>
            </div>
          </div>
          <div class="details">
            <div class="details-title">
              <span class="star">*</span>
              <span>车牌号：</span>
            </div>
            <div class="details-r">
              <el-input v-model="plate_number" clearable placeholder="请输入车牌号"></el-input>
              <div style="clear:both;"></div>
            </div>
          </div>
        </div>
        <div class="button">
          <el-button class="button-cancel" @click="cancelClick()">取消</el-button>
          <el-button class="button-confirm" @click="confirmClick()">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newVehicleDialog:false,
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      input: "",
      VIN:"",
      customer_status:"",
      plate_number:"",
      plate_vin:"",
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.getDataList();
    });
  },
  methods: {
    handleSizeChange(data){
      // debugger
    },
    currentChange(data){
      this.endnum = data;
      this.startnum = data-1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if(this.totalNum > 10){
        this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      } else {
        this.yemiandata=this.tableData;
      }
    },
    getDataList(vin){
      if(vin == undefined){
        vin = "";
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"getCustomerVins",
        vin:vin,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer2/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.customer_status = su.data.customer_status;
            this.totalNum = this.tableData.length;
            if(this.totalNum > 10){
              this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
            } else {
              this.yemiandata=this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    searchClick(){
      this.startnum = 0;
      this.endnum = 1;
      this.totalNum = 0;
      this.getDataList(this.VIN);
    },
    cancelClick(){
      this.newVehicleDialog = false;
      this.plate_vin = "";
      this.plate_number = "";
    },
    addClick(){
      this.newVehicleDialog = true;
    },
    confirmClick(){
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"saveCustomerVin",
        vin:this.plate_vin,
        plate_number:this.plate_number,
      };
      this.$api({
        method: "post",
        url: "/api.php/Customer2/index",
        data: params,
        transformRequest: [
          data => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          }
        ]
      })
        .then(su => {
          if (su.data.code == 1) {
            this.newVehicleDialog = false;
            this.getDataList();
            this.plate_vin = "";
            this.plate_number = "";
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900)  {
              } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch(err => {});
    },
    deleteClick(row){
      // debugger

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action:"deleteCustomerVin",
        vin:row.vin,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: ""
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/Customer2/index",
            data: params,
            transformRequest: [
              data => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              }
            ]
          })
            .then(su => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList();
              } else if (su.data.code == 300)  {
                localStorage.clear(); 
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900)  {
              } else  {
                this.$message.error(su.data.message);
              }
            })
            .catch(err => {});
        })
        .catch(() => {});
    },
  }
};
</script>

<style scoped lang="scss">
.vehicle {
    padding:20px 0;
  .vehicle-top {
    .top-l {
      //   display: flex;
      float: left;
      width: 50%;
      margin-left: 1%;
      .el-input {
        width: 20%;
        float: left;
      }
      .top-l-search {
        background-color: #0071bd;
        border: none;
        color: #fefffd;
        margin-left: 16px;
        float: left;
      }
      .v-new {
        background-color: #ec6901;
        border: none;
        color: #fefffd;
        margin-left: 16px;
        float: left;
      }
    }
  }
  .vehicle-bottom {
    .vehicle-table {
      width: 98%;
      margin-left: 1%;
      margin-top: 20px;
      .user-delete {
        width: 54px;
        height: 30px;
        padding: 0;
        background-color: #00b270;
        border:none;
        color: #fefffd;
        margin-left: 5px;
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      padding-bottom: 24px;
      margin-top: 20px;
      margin-right: 18px;
    }
  }
  .new-vehicle-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .new-vehicle-content {
      .text-input {
        .details {
          margin-bottom: 16px;
          .details-title {
            display: inline-block;
            width: 30%;
            text-align: right;
            vertical-align: top;
            margin-top: 11px;
            .star {
              color: #ee0002;
            }
          }
          .details-r {
            display: inline-block;
            width: 65%;
            .el-input {
              width: 60%;
              float: left;
            }
          }
          .details-r2 {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
        }
      }
      .button {
        margin-top: 20px;
        .button-cancel {
          width: 16%;
          height: 50px;
          background-color: #0071BD;
          border:none;
          color:#ffffff;
        }
        .button-confirm {
          width: 16%;
          height: 50px;
          background-color: #02B36F;
          border:none;
          color:#ffffff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/membershipManagement/vehicle.vue